import React, { FC, useState } from 'react';
import Collapsible from './Collapsible';
import FirstBlock from './FirstBlock';
import SecondBlock from './SecondBlock';
import EvaluationsBlock from './EvaluationsBlock';
import { DivisionLine } from './styled';
import FinalGradeBlock from './FinalGradeBlock';
import FormulaBlock from './FormulaBlock';
import ConvalidatedBlock from './ConvalidatedBlock';
import AttendanceBlock from './AttendanceBlock';

interface IProps {
  courseData: any;
  relatedCourse?: any;
  selectPeriod: string;
}

const CourseCollapsible: FC<IProps> = ({
  courseData,
  relatedCourse,
  selectPeriod
}) => {
  const [show, setShow] = useState(false);

  let color = '';
  let courseStatusRenamed = '';

  switch (courseData.approvalStatus) {
    case 'PASSED': {
      color = 'var(--course-success)';
      courseStatusRenamed = 'Aprobado';
      break;
    }
    case 'NOT_PASSED': {
      color = 'var(--course-failed)';
      courseStatusRenamed = 'Desaprobado';
      break;
    }
    case 'WITHDRAWN': {
      color = 'var(--course-retired)';
      courseStatusRenamed = 'Retirado';
      break;
    }
    case 'VALIDATED': {
      color = 'var(--course-convalidated)';
      courseStatusRenamed = 'Convalidado';
      break;
    }
    case 'SANCTIONED': {
      color = 'var(--course-convalidated)';
      courseStatusRenamed = 'Sancionado';
      break;
    }
    default: {
      color = 'var(--course-ongoing)';
      courseStatusRenamed = 'En curso';
    }
  }

  return (
    <div data-testid="cmp-course-collapsible">
      <Collapsible
        color={color}
        setShow={setShow}
        show={show}
        title={courseData.title}
        catalogNumber={courseData.catalogNumber}
        courseStatus={courseStatusRenamed}
        finalGrade={courseData.average}
      >
        {courseStatusRenamed !== 'Convalidado' ? (
          <>
            <FirstBlock
              courseModality={courseData.courseMode}
              schedule={courseData.schedule}
              professors={courseData.professors}
              module={courseData.module}
            />
            <DivisionLine
              backgroundColor={'var(--text-text-disabled)'}
              margin={'16px 0px'}
            />
            <SecondBlock
              weeklyHours={courseData.weeklyHours}
              credits={courseData.credits}
              numberOfTimes={courseData.numberTimes}
              section={courseData.section}
            />
            <DivisionLine
              backgroundColor={'var(--text-text-disabled)'}
              margin={'16px 0px'}
            />
            <EvaluationsBlock
              evaluations={courseData?.evaluations}
              relatedCourse={relatedCourse}
            />
            <FormulaBlock formula={courseData.formula} />
            <FinalGradeBlock
              finalGrade={courseData.average}
              courseStatus={courseStatusRenamed}
            />
            {courseData.courseMode !== 'VT' &&
              Number(selectPeriod.substring(1, 3)) >= 23 && (
                <AttendanceBlock
                  courseTitle={courseData.title}
                  catalogNumber={courseData.catalogNumber}
                  sectionId={courseData.section}
                  selectPeriod={selectPeriod}
                />
              )}
          </>
        ) : (
          <ConvalidatedBlock
            finalGrade={courseData.average}
            credits={courseData.credits}
          />
        )}
      </Collapsible>
    </div>
  );
};
export default CourseCollapsible;
